import { render, staticRenderFns } from "./GamePageLayout.vue?vue&type=template&id=03be1406&scoped=true&"
import script from "./GamePageLayout.vue?vue&type=script&lang=js&"
export * from "./GamePageLayout.vue?vue&type=script&lang=js&"
import style0 from "./GamePageLayout.vue?vue&type=style&index=0&id=03be1406&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03be1406",
  null
  
)

export default component.exports